function getUnapprovedUsers({ output, services }) {
  let fetchOptions = {
    skip: 0,
    limit: 1000000,
    approved: false,
    sort: { lastname: 1 }
  }
  services.Http
    .post('/api/users/get/', fetchOptions)
    .then(output.success)
    .catch(output.error)
}

getUnapprovedUsers.async = true
export default getUnapprovedUsers



// WEBPACK FOOTER //
// ./src/modules/app/actions/getUnapprovedUsers.js